














































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Tab,
  Tabs,
} from "vant";
import api from "../../../components/http/api";
import { CouponRequestInfo } from "../coupon/CouponApi";

declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
})
export default class XjqyAwardingDetail extends Vue {
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;

  private activityid: string = "";
  private p1text: string = "";
  private num: string = "";

  private buttonActive: boolean = false;

  protected created() {
    this.activityid = this.$route.params.activityid;
    if (this.activityid === "1") {
      this.p1text = "8元代金券";
    } else if (this.activityid === "2") {
      this.p1text = "10元代金券";
    } else if (this.activityid === "3") {
      this.p1text = "20元代金券";
    }
  }

  protected getSydCoupon() {
    this.couponRequestInfo.activityid = this.$route.params.activityid;
    api
      .post("/weixinmp/xsyx/myuser/getXjqyActivityInfo", this.couponRequestInfo)
      .then((res: any) => {
        if (res.data.owner === "1") {
          // 498供应商
          window.location.href =
            process.env.VUE_APP_498_URL +
            encodeURIComponent(
              process.env.VUE_APP_URLFRONT +
                "/main/xjqy/xjqyCouponResult498?a=" +
                this.couponRequestInfo.activityid
            );
        } else if (res.data.owner === "null") {
          this.$toast("该活动不存在，请联系工作人员");
        } else if (res.data.owner === "NOHD") {
          this.$toast("活动尚未开始");
        } else {
          this.$router.push(
            "/main/xjqy/xjqyCouponResult/" + this.couponRequestInfo.activityid
          );
        }
      });
  }
}
